module.exports = __webpack_public_path__ + "static/media/flash-sale.c7cf0510.png";